import {ToolbarProps} from 'react-big-calendar';
import React, {useEffect, useState} from 'react';
import {ReactComponent as ArrayIcon} from '../../../assets/main/groups/main-table/array.svg';
import {ReactComponent as ArrayLeftIcon} from '../../../assets/main/groups/main-table/array-left.svg';
import {ReactComponent as NotSelectDataIcon} from '../../../assets/i/not-select-data.svg';
import {
    StudentsFilter
} from "components/pages/groups/group-container/students/students-pages/students-timetable/students-filter/StudentsFilter";
import {useAppSelector} from "common/hook";
import {Select} from "antd";
import {SelectValue} from "antd/es/select";
import {useNavigate} from 'react-router-dom';


interface CustomToolbarDevProps {
    label: string;
    setSendFilter: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CustomToolbarDev: React.FC<ToolbarProps<Event, object> & CustomToolbarDevProps> = (
    {
        onNavigate,
        label,
        setSendFilter,
    }
) => {
    const users = useAppSelector(state => state.scheduleUser.users);
    const navigate = useNavigate();
    const [searching, setSearching] = useState(false);
    const [selectedUser, setSelectedUser] = useState<string | undefined>(undefined);

    const currentUserId = window.location.pathname.split('/').pop();

    useEffect(() => {
        const handleStartSearch = () => setSearching(true);
        const handleEndSearch = () => setSearching(false);

        window.addEventListener('popstate', handleStartSearch);
        window.addEventListener('load', handleEndSearch);

        return () => {
            window.removeEventListener('popstate', handleStartSearch);
            window.removeEventListener('load', handleEndSearch);
        };
    }, []);

    useEffect(() => {
        if (!searching && currentUserId && users) {
            const currentUser = users.find(user => user.value === currentUserId);
            if (currentUser) {
                setSelectedUser(currentUser.value);
            }
        }
    }, [searching, currentUserId, users]);

    const goToBack = () => {
        onNavigate('PREV');
    };

    const goToNext = () => {
        onNavigate('NEXT');
    };

    const handleUserChange = (value: SelectValue) => {
        if (value !== undefined) {
            setSelectedUser(value.toString());
            navigate(`/calendar-dev/${value}`);
        }
    };

    return (
        <div className='toolbar-block'>
            <div className="rbc-toolbar">
                <span className="rbc-btn-group">
                    <button type="button" onClick={goToBack}>
                        <ArrayLeftIcon/>
                    </button>
                </span>
                <span className="rbc-toolbar-label">{label}</span>
                <span className="rbc-btn-group">
                    <button type="button" onClick={goToNext}>
                        <ArrayIcon/>
                    </button>
                </span>
            </div>

            <nav className="navbar">
                <div className="navbar-right">
                    <div className="nav-block dev">
                        <div className='custom-select dev'>
                            <Select
                                showSearch
                                style={{width: '100%', cursor: 'pointer'}}
                                placeholder={searching ? "Поиск..." : "Поиск..."}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                onChange={handleUserChange}
                                options={users ? users.map(user => ({
                                    value: user.value,
                                    label: user.label,
                                })) : []}
                                value={selectedUser}
                                notFoundContent={users && users.length === 0 && (
                                    <div className="custom-not-found">
                                        <NotSelectDataIcon/>
                                        <p className='custom-not-found-text'>Нет данных</p>
                                    </div>
                                )}
                            />
                        </div>

                        <StudentsFilter setSendFilter={setSendFilter} top={true}/>
                        {/*<button className="btn exit"><span>Выйти</span></button>*/}
                        {/*<button className="button-exit"><span>Выйти</span></button>*/}
                    </div>
                </div>
            </nav>
        </div>
    );
};

